"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0;\n  margin-bottom: 1rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorAccent;
});

var ConfirmStep = function ConfirmStep(_ref) {
  var translations = _ref.translations,
      isSubmitting = _ref.isSubmitting,
      onStepClicked = _ref.onStepClicked,
      isStepValid = _ref.isStepValid,
      values = _ref.values,
      dirty = _ref.dirty,
      isNonUk = _ref.isNonUk,
      signupError = _ref.signupError;
  var defaultSignupFields = [{
    field: 'email',
    label: 'Email'
  }, {
    field: 'firstName',
    label: 'First Name'
  }, {
    field: 'lastName',
    label: 'Last Name'
  }, {
    field: 'username',
    label: 'Username'
  }, {
    field: 'birthDate',
    label: 'Birth Date'
  }, {
    field: 'mobileNumber',
    label: 'Telephone Number'
  }].concat(_toConsumableArray(isNonUk ? [] : [{
    field: 'postcode',
    label: 'Postcode'
  }]), _toConsumableArray(isNonUk ? [] : [{
    field: 'street1',
    label: 'Address Line 1'
  }]), [{
    field: 'street2',
    label: 'Address Line 2'
  }], _toConsumableArray(isNonUk ? [] : [{
    field: 'city',
    label: 'City / Town'
  }]), [{
    field: 'county',
    label: 'County'
  }]);
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.TitleStack, {
    title: "Data preview",
    subtitle: "Please confirm the following information is correct"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Form, null, defaultSignupFields.map(function (item) {
    return values[item.field] ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowLabel, null, item.label), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      style: {
        paddingLeft: "1rem"
      },
      value: values[item.field],
      isReadOnly: true
    })) : null;
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    margin: "0 0 1rem",
    isVisible: signupError !== undefined
  }, signupError), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    type: "submit",
    isLoading: isSubmitting,
    disabled: !isStepValid || !dirty,
    style: {
      marginBottom: "1rem"
    }
  }, translations.finish), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(3);
    },
    isDefault: true
  }, translations.edit));
};

var _default = ConfirmStep;
exports.default = _default;